'use strict';
let map, marker, imgServ, curServ;
const init = (eAI) => {
	imgServ = new Array();
	addEventListenerList(document.querySelectorAll('.icos-serv > div img'), 'click', showProdService);
	getScript( 'https://maps.googleapis.com/maps/api/js?key=AIzaSyALUjS_TC_VAhVXQaayjv_KsOhVlWZwOAo&', function() {
		map = new google.maps.Map(document.getElementById('map'), {
			center: {lat: 9.951589, lng: -84.060395},
			zoom: 17,
		});
		marker = new google.maps.Marker({
			position: {lat: 9.951589, lng: -84.060395},
			map: map,
			title: 'Graficarte'
		});
	});
};
const showProdService = (eSPS) => {
	//let _cps = (eSPS.target.dataset.ps);
	curServ = eSPS.target;
	document.body.classList.add('page-all-main-body');
	appendPreloader('Cargando Info...');
	postAjax(curServ.dataset.ps+'.html', {f: Date.now()}, function(eD){
		console.log(eD);
		removePreloader();
		document.body.appendChild(createCustomElement('div',{'class':'page-all'},[eD, createCustomElement('a',{'href':'#','class':'modal_page_all'},['×'])]));
		document.querySelector('.modal_page_all').addEventListener('click',function(eC){
			eC.preventDefault();
			document.body.removeChild(document.querySelector('.page-all'));
			document.body.classList.remove('page-all-main-body');
		});
	});
};
const addEventListenerList = (list, event, fn) => {
	for (var i = 0, len = list.length; i < len; i++) {
		list[i].addEventListener(event, fn, !1);
	}
};
const getScript = (source, callback) => {
	var script = document.createElement('script');
	var prior = document.getElementsByTagName('script')[0];
	script.async = 1;

	script.onload = script.onreadystatechange = function( _, isAbort ) {
		if(isAbort || !script.readyState || /loaded|complete/.test(script.readyState) ) {
			script.onload = script.onreadystatechange = null;
			script = undefined;

			if(!isAbort) { if(callback) callback(); }
		}
	};

	script.src = source;
	prior.parentNode.insertBefore(script, prior);
};
const appendPreloader = (pl_txt) => {
	let pldiv = createCustomElement('div',{},[
		createCustomElement('div',{'class':'spinner_mc'}),
		createCustomElement('div',{'class':'status_sp_txt'},[pl_txt])
	]);
	let overall = createCustomElement('div',{'class':'modal-pl'},[pldiv]);
	document.body.style.overflow = 'hidden';
	document.body.appendChild(overall);
};
const removePreloader = (eRP) => {
	if(eRP) {
		eRP.preventDefault();
	}
	document.body.style.overflow = 'visible';
	document.body.removeChild(document.querySelector('.modal-pl'));
};
const appendModal = (modalTxt, modalTittle, modalFooter) => {
	let modCont = new Array();
	if(modalTittle != undefined) {
		modCont.push( createCustomElement('div',{'class':'modal_header'},[ createCustomElement('h3',{},[modalTittle]) ]) );
	}
	modCont.push( createCustomElement('div',{'class':'modal_body'},[modalTxt]) );
	if(modalFooter != undefined) {
		modCont.push( createCustomElement('div',{'class':'modal_footer'},[modalFooter]) );
	}
	modCont.push( createCustomElement('a',{'href':'#','class':'modal_close'},['×']) );
	let mdl = createCustomElement('div',{'class':'modalAll'},modCont);
	let blk = createCustomElement('div',{'id':'modalDialog'},[mdl]);
	blk.addEventListener('click', e => {
		if(e.target === blk) {
			removeModal();
		}
	});
	document.body.style.overflow = 'hidden';
	document.body.appendChild(blk);
	document.querySelector('.modal_close').addEventListener('click',removeModal);
};
const removeModal = (eRM) => {
	if(eRM) {
		eRM.preventDefault();
	}
	document.body.style.overflow = 'visible';
	document.body.removeChild(document.getElementById('modalDialog'));
};
// https://github.com/escueladigital/EDui
// Crear elementos con atributos e hijo
const createCustomElement = (element,attributes,children) => {
	let customElement = document.createElement(element);
	if (children !== undefined) children.forEach(el => {
		if (el.nodeType) {
			if (el.nodeType === 1 || el.nodeType === 11) customElement.appendChild(el);
		} else {
			customElement.innerHTML += el;
		}
	});
	addAttributes(customElement,attributes);
	return customElement;
};

// Añadir un objeto de atributos a un elemento
const addAttributes = (element, attrObj) => {
	for (let attr in attrObj) {
		if (attrObj.hasOwnProperty(attr)) {
			element.setAttribute(attr,attrObj[attr]);
		}
	}
};

// https://plainjs.com/javascript/ajax/send-ajax-get-and-post-requests-47/
const postAjax = (url, data, success) => {
	var params = typeof data == 'string' ? data : Object.keys(data).map(
			function(k){ return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]) }
		).join('&');

	var xhr = window.XMLHttpRequest ? new XMLHttpRequest() : new ActiveXObject("Microsoft.XMLHTTP");
	xhr.open('POST', url);
	xhr.onreadystatechange = function() {
		if (xhr.readyState>3 && xhr.status==200) { success(xhr.responseText); }
	};
	xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
	xhr.send(params);
	return xhr;
};
document.addEventListener('DOMContentLoaded', init, !1);